import * as React from "react";
import BookCalendarWrapper from "../../BookCalendar/BookCalendarWrapper";
import "../Calendar/Calendar.css";
import "./MyBooks.css";
import { Route, Switch } from "react-router-dom";
import MediaQuery from "react-responsive";
import { MOBILE_MAX_WIDTH } from "../../../utils";
import MobileBook from "../../MobileBooks/MobileBooks";
import { Sections } from "../../BookCalendar/BooksSidebar/BooksSidebar";
import CardsManager from "../../CardsManager/CardsManager";

const MyBooks: React.FunctionComponent = (props) => {
	return (
		<CardsManager>
			{(callbacks) => {
				return (
					<div className="calendarPage">
						<div className="calendarPage__wrapper myBooks">
							<div className="calendarPage__calendar">
								<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
									<Route path="/:id">
										<BookCalendarWrapper callbacks={callbacks}/>
									</Route>

									<Route path="/" exact>
										<BookCalendarWrapper callbacks={callbacks}/>
									</Route>
								</MediaQuery>

								<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
									<Switch>
										<Route path="/" exact>
											<MobileBook callbacks={callbacks} />
										</Route>

										<Route path="/alreadyRead">
											<BookCalendarWrapper
												section={Sections.AlreadyRead}
												callbacks={callbacks}
											/>
										</Route>

										<Route path="/wantRead">
											<BookCalendarWrapper
												section={Sections.WantRead}
												callbacks={callbacks}
											/>
										</Route>

										<Route path="/readNow">
											<BookCalendarWrapper
												section={Sections.ReadNow}
												callbacks={callbacks}
											/>
										</Route>

										<Route path="/all" exact>
											<BookCalendarWrapper
												section={Sections.All}
												callbacks={callbacks}
											/>
										</Route>

										<Route path="/all/:category">
											<BookCalendarWrapper
												section={Sections.All}
												callbacks={callbacks}
											/>
										</Route>

										<Route path="/:id">
											<BookCalendarWrapper callbacks={callbacks} />
										</Route>
									</Switch>
								</MediaQuery>
							</div>
						</div>
					</div>
				);
			}}
		</CardsManager>
	);
};

export default MyBooks;
